import request from '@/utils/request'


export function getQueue(){
    return request({
      url: `/api/exportqueue`,
      method: "get"
    });
}

